<template>
  <div class="oneui login">
    <div class="center-div"></div>
    <div class="login-page">
      <div class="pagedots"></div>

      <v-style
        v-if="funnel.infoStage >= 4"
      >.pagedots:before { width: {{ 10 + 10 * funnel.infoStage }}% !important; }</v-style>
      <v-style v-if="funnel.type">.pagedots:before { width: 65% !important; }</v-style>
      <v-style
        v-if="typeof funnel.hasAccount == 'boolean'"
      >.pagedots:before { width: 95% !important; }</v-style>
      <div v-if="funnel.infoStage == 4">
        <v-style v-if="!funnel.hasAccount && funnel.loginStep == 'email'">
          .funnelInputs:before { content: "Enter an email for your whole family to use."
          }
        </v-style>
        <v-style v-if="!funnel.hasAccount && funnel.loginStep == 'password'">
          .funnelInputs:before { content: "Enter an password for your whole family to use."
          }
        </v-style>
        <v-style
          v-if="funnel.type == ''"
        >.funnelButtons:before { content: "Are you a parent or a child?" }</v-style>
        <v-style
          v-else-if="funnel.hasAccount == '' && funnel.hasAccount !== false"
        >.funnelButtons:before { content: "Does your family have an account?" }</v-style>
        <div v-else-if="funnel.loginStep == 'email' && funnel.type == 'parent'">
          <v-style v-if="funnel.hasAccount">
            .funnelInputs:before { content: "Enter the email your family entered during
            signup." }
          </v-style>
        </div>
        <div v-if="funnel.loginStep == 'password'">
          <v-style v-if="funnel.hasAccount">
            .funnelInputs:before { content: "Enter the password your family chose during
            signup."; }
          </v-style>
          <v-style v-else>
            .funnelInputs:before { content: "Choose a password to use for your whole
            family."; }
          </v-style>
        </div>
      </div>
      <div class="funnelWrapper" v-if="funnel.infoStage !== 4">
        <div>
          <GraphicItem :index="funnel.infoStage" />
        </div>
        <div class="funnelButtons">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <button
            @click="funnel.infoStage = funnel.infoStage == 4 ? 0 : funnel.infoStage + 1"
            class="btn bnt-wide btn-solid"
          >
            <p
              style="
                            margin: 0px;
                            display: grid;
                            grid-template-columns: 3fr 1fr;
                            line-height: 100%;
                          "
            >
              <span style="text-align: left; padding: 0 30px">Next</span>
              <span style="font-size: 25px">➡</span>
            </p>
          </button>
          <span></span>
        </div>
      </div>
      <div class="funnelWrapper" v-if="funnel.infoStage == 4 && funnel.type == ''">
        <div>
          <GraphicItem />
        </div>
        <div class="funnelButtons">
          <span></span>
          <button @click="funnel.type = 'parent'" class="btn bnt-wide btn-solid">Parent</button>
          <span></span>
          <span></span>
          <button
            @click="funnel.hasAccount = true; funnel.type = 'parent';"
            class="btn bnt-wide btn-solid"
          >Child</button>
          <span></span>
        </div>
      </div>
      <div
        class="funnelWrapper"
        v-else-if="funnel.infoStage == 4 && typeof funnel.hasAccount == 'string'"
      >
        <div>
          <GraphicItem />
        </div>
        <div class="funnelButtons">
          <span></span>
          <button
            @click="funnel.hasAccount = true"
            class="btn bnt-wide btn-solid"
          >Yes, I have an account</button>
          <span></span>
          <span></span>
          <button
            @click="funnel.hasAccount = false && funnel.type !== 'child'"
            class="btn bnt-wide btn-solid"
          >No, I'm new here 🙂</button>
          <span></span>
        </div>
      </div>
      <div
        class="funnelWrapper"
        v-else-if="funnel.infoStage == 4 && typeof funnel.hasAccount !== 'string'"
      >
        <div>
          <GraphicItem refname="welcome" />
        </div>
        <div class="funnelInputs">
          <form
            onsubmit="return false"
            v-if="funnel.type == 'parent' && typeof funnel.hasAccount !== 'string'"
          >
            <center
              v-if="this.$data.showLogin"
              :updater="this.$data.showLogin"
              :class="`view_${currentView} loginForm`"
            >
              <div class="inputs">
                <FormulateInput
                  v-if="funnel.loginStep == 'email'"
                  autofocus
                  v-model="email"
                  type="email"
                  required
                  @validation="passwordIsValid"
                  :placeholder="$t('pages.login.email')"
                  validation="required|email"
                  error-behavior="live"
                />
                <FormulateInput
                  v-if="funnel.loginStep == 'password'"
                  v-model="password"
                  required
                  error-behavior="live"
                  autofocus
                  type="password"
                  @keypress="checkSubmit"
                  @validation="passwordIsValid"
                  validation="^required|min:8,length|matches:/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/"
                  :validation-messages="
                                funnel.hasAccount
                                  ? null
                                  : {
                                      matches:
                                        'Passwords must contain: one capital letter, one lowercase letter and a number.',
                                    }
                              "
                  :placeholder="$t('pages.login.password')"
                />
              </div>
              <div class="buttonGrid">
                <button
                  v-if="funnel.loginStep == 'email' && canContinue"
                  class="btn bnt-wide btn-solid"
                  @click="gotoPasswordStep"
                >
                  <p
                    style="
                                  margin: 0px;
                                  display: grid;
                                  grid-template-columns: 3fr 1fr;
                                  line-height: 100%;
                                "
                  >
                    <span style="text-align: left; padding: 0 30px">
                      {{
                      $t("general.next")
                      }}
                    </span>
                    <span style="font-size: 25px">➡</span>
                  </p>
                </button>
                <button
                  @click="funnel.hasAccount == true ? login(false) : signup()"
                  type="button"
                  class="btn bnt-wide btn-solid"
                  v-if="funnel.loginStep == 'password' && funnel.hasAccount == true"
                >{{ $t("pages.login.login") }}</button>
                <button
                  @click="
                                funnel.loginStep == 'password' && funnel.hasAccount == true
                                  ? login(false)
                                  : signup()
                              "
                  type="button"
                  :disabled="disableButtons && !canContinue"
                  class="btn bnt-wide btn-solid"
                  v-else-if="
                                funnel.loginStep == 'password' &&
                                funnel.hasAccount == false &&
                                canContinue
                              "
                >{{ $t("pages.login.createAccount") }}</button>
                <button
                  v-if="funnel.loginStep == 'password'"
                  @click="funnel.loginStep = 'email'"
                  type="button"
                  class="btn bnt-wide btn-solid"
                >{{ $t("generic.back") }}</button>
              </div>
            </center>
            <center v-else :updater="this.$data.showLogin">
              <div class="preloader-wrapper big active">
                <div class="spinner-layer">
                  <div class="circle-clipper left">
                    <div class="circle"></div>
                  </div>
                  <div class="gap-patch">
                    <div class="circle"></div>
                  </div>
                  <div class="circle-clipper right">
                    <div class="circle"></div>
                  </div>
                </div>
              </div>
            </center>
          </form>
        </div>
      </div>

      <div
        class="funnelWrapper"
        v-if="
                      funnel.infoStage == 4 &&
                      typeof funnel.hasAccount !== 'string' &&
                      funnel.hasAccount == false &&
                      funnel.type == 'child'
                    "
      >
        <div></div>
        <div class="funnelButtons">
          <span></span>

          <div class="childSignup">
            <div>
              <input
                required
                v-model="link.name"
                :placeholder="$t('pages.parents.addChild.name')"
                autocomplete="off"
                v-if="!link.svg"
              />
              <input
                required
                type="number"
                v-if="!link.svg"
                v-model="link.age"
                max="17"
                pattern="[0-9]*"
                min="1"
                :placeholder="$t('pages.parents.addChild.age')"
              />
            </div>
            <span></span>

            <div class="qr_code" v-html="link.svg"></div>
            <div
              v-if="link.code"
              style="
                            padding: 10px;
                            margin-bottom: 10px;
                            background: var(--theme-color);
                            border-radius: var(--modal-radius);
                            color: white;
                          "
            >{{ link.code }}</div>
          </div>
          <span></span>
          <span></span>
          <span
            v-if="link.svg"
            style="color: var(--walkthru-color)"
          >Show this code to your parents so they can link your account</span>
          <span v-else></span>
          <span></span>
          <span></span>

          <button
            class="btn btn-wide"
            @click="createLinkableDevice()"
            v-if="!link.svg"
          >{{ $t("pages.login.generateCode") }}</button>
          <button
            class="btn btn-wide"
            v-else
            @click="link = { code: null, svg: null }"
          >{{ $t("pages.login.regenerateCode") }}</button>
          <span></span>
          <span></span>

          <button
            @click="
                          () =>
                            (funnel = { type: '', hasAccount: '', infoStage: 0, loginStep: 'email' })
                        "
            class="btn btn-wide"
          >Back</button>
        </div>
      </div>
    </div>
  </div>
</template>

            <script scoped>
/* NPM IMPORTS */
import Parse from "parse";
import GraphicItem from "@/components/GraphicItem";
import * as ModernModals from "modern-modals";

/* JS IMPORTS */
import * as CCParse from "../utilities/parse";

export default {
  components: {
    GraphicItem
  },
  data() {
    return {
      canContinue: false,
      showLogin: false,
      email: "",
      password: "",
      passwordConfirm: "",
      currentView: "signup",
      disableButtons: false,
      funnel: {
        type: "parent",
        hasAccount: "",
        infoStage: 0,
        loginStep: "email"
      },
      link: {
        svg: null,
        name: null,
        age: null,
        code: null
      }
    };
  },
  mounted() {
    Parse.User.current()
      ? this.$router.push("/parents")
      : (this.$data.showLogin = true);
    window.childSignup = new ModernModals.HTMLModal($_("kidLogin"));
  },
  methods: {
    passwordIsValid(x) {
      this.$data.canContinue = !x.hasErrors;
    },
    gotoPasswordStep() {
      this.$data.funnel.loginStep = "password";
      this.$data.canContinue = false;
    },
    checkSubmit(e) {
      if (e?.keyCode == 13) {
        this.$data.funnel.hasAccount ? this.login() : this.signup(false);
      }
    },
    async signup() {
      var user = new Parse.User();
      if (this.$data.password.length < 8) {
        ModernModals.alert(
          this.$t("pages.login.passTooShort.title"),
          this.$t("generic.error.tryAgain")
        );
        return;
      }
      user.set("username", this.$data.email);
      user.set("email", this.$data.email);
      user.set("app", "hero");
      user.set("password", this.$data.password);
      user.set("passwd", this.$data.password);
      this.$data.disableButtons = true;
      await user
        .signUp()
        .then(async () => {
          var roleQuery = new Parse.Query(Parse.Role);
          roleQuery.equalTo("name", "ParentAccount");
          let role = await roleQuery.first();
          role.getUsers().add(user);
          await role.save();
          await CCParse.getParent(this);
          gtag("event", "sign_up");
          this.login(true);
        })
        .catch(async e => {
          await ModernModals.alert(e.message);
          this.$data.disableButtons = false;
        });
    },
    async createLinkableDevice() {
      let data = await CCParse.createLinkableDevice(
        this.$data.link.name,
        this.$data.link.age
      );
      this.$data.link = { svg: data.svg, code: data.id };
      let linkinterval;
      linkinterval = setInterval(() => {
        CCParse.loginViaLink()
          .then(x => {
            clearInterval(linkinterval);
            this.login(false, x);
          })
          .catch();
      }, 500);
    },
    async login(isFirstLogin, creds) {
      let loginInfo = {
        username: null,
        password: null
      };
      if (creds) {
        loginInfo = creds;
      } else {
        loginInfo = {
          username: this.$data.email,
          password: this.$data.password
        };
      }
      try {
        await Parse.User.logIn(loginInfo.username, loginInfo.password)
          .then(user => {
            if (isFirstLogin) {
              location.href = "/#/kids/new";
              location.reload(true);
            } else {
              location.href = "/#/parents";
              location.reload(true);
            }
          })
          .catch(async e => {
            $$("input").forEach(x => x.blur());
            await ModernModals.alert(e.message);
            this.$data.disableButtons = false;
          });
      } catch {
        $$("input").forEach(x => x.blur());
        ModernModals.alert("Server currently down. Sorry 😢.");
      }
    }
  },
  watch: {
    "funnel.hasAccount": function(a, b) {
      console.log(a, b);
      if (this.$data.funnel.type == "child") {
        if (typeof a !== "string" && !a) {
        } else {
          ModernModals.alert("Please give device to parent to login");
          this.$data.funnel.type = "parent";
        }
      }
    }
  }
};
</script>

            <style lang="scss" scoped>
.innnerTab {
  padding: 50%;
  min-height: calc(100vh - var(--top-padding));
  width: 100%;
}
.oneui {
  background: linear-gradient(180deg, #fefefe 0%, #dddff0 96%);

  @media (prefers-color-scheme: dark) {
    background: linear-gradient(180deg, #030303 0%, #1322a3 96%);
  }
}
.page {
  background: transparent;
}
.qr_code {
  width: 50%;
  margin: 0 25%;
}
.btn-solid {
  //  border: 3px solid #0135eb !important;
  line-height: calc(50px - 6px);
  height: 50px;
  font-family: "SF Pro Display", "SF Pro Rounded", "文泉驿微米黑", "Helvetica",
    "Helvetica Neue", "SF Pro Text", "Roboto", "Arial", “STXihei”, “华文细黑”,
    “Microsoft YaHei”, “微软雅黑”, sans-serif;
}
.funnelWrapper {
  text-align: center;
  overflow: hidden;
  vertical-align: -webkit-baseline-middle;
  .funnelButtons {
    // grid-template-rows: 1fr 1fr;
    display: grid;
    grid-gap: 10px;
    font-size: 20px;
    position: fixed;
    bottom: 48px;
    grid-template-columns: 0.15fr 1fr 0.15fr;
    width: 100%;
    z-index: 40;
  }
  .funnelInputs {
    @extend .funnelButtons;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
  }
}
.btn {
  text-transform: none;
  background: var(--layout-bg);
  color: rgb(38, 64, 139);
  box-shadow: rgba(0, 0, 0, 0.05) -1px 3px 11px 2px;
  @media (prefers-color-scheme: dark) {
    background: #090e3d;
    color: white;
  }
  border-radius: 13px;
}
.childSignup {
  input {
    width: 100%;
    &:first-of-type {
      margin-bottom: 10px;
    }
  }
}
.pagedots {
  position: fixed;
  width: 75%;
  background: rgba(110, 110, 110, 0.47);
  height: 10px;
  border-radius: 40px;
  top: 20px;
  /* right: 25%; */
  left: 50%;
  transform: translateX(-50%);

  &:before {
    position: absolute;
    display: block;
    /* left: 33%; */
    width: 15%;
    content: "a";
    background: #26408b;
    height: inherit;
    color: transparent;
    transition: all 1.5s cubic-bezier(0.47, 0, 0, 0.85);
    border-radius: 40px;
  }
}
.funnelButtons:before {
  position: fixed;
  transform: translate(50%, -125%);
  right: 50%;
  color: var(--walkthru-color);
}
.funnelInputs:before {
  width: 85%;
  position: fixed;
  transform: translate(50%, -125%);
  right: 50%;
}
</style>
        </div>
      </div>
    </div>
  </div>
</template>
